import DataTableHierarchical from '../DataTableHierarchical.vue'
import { keepDimensions, buildCropFunction, valueAsNumber } from '../dataFilter'
import api from '../api'

export default {
  id: 'data-table',
  label: 'Tableau Hiérarchique',
  component: DataTableHierarchical,
  multipleMeasure: () => true,
  dimensions: 1,
  adaptater: (data, vue) => {
    const props = {
      measures: vue.measure,
      formatters: {},
      dimension: vue.dimension.filter(d => {
        return vue.activeDimensions.indexOf(api.dimension.uniqueName(d.value)) !== -1
      })[0]
    }
    vue.metadata.measures.forEach(m => {
      props.formatters[api.measure.uniqueName(m)] = vue.buildMeasureFormatter(
        api.measure.uniqueName(m)
      )
    })
    vue.buildProps(props)
    let result = data.filter(d => d.Group0UniqueName.substr(-11) !== '.DATAMEMBER').map(d => {
      const r = {}
      Object.keys(d).forEach(k => {
        r[k] = d[k]
      })
      vue.measure.forEach(m => {
        r[api.measure.name(m)] = valueAsNumber(r[api.measure.name(m)])
      })
      return r
    }).filter(d => !vue.noEmpty || vue.measure.map(m => d[api.measure.name(m)]).some(v => v))
    if (vue.measure.length === 1) {
      result = buildCropFunction(d => d[api.measure.name(vue.measure[0])], vue)(result)
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/DataTableHierarchical.js